"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCyclicTabbing = void 0;
const definition_1 = require("@wix/viewer-service-environment/definition");
const fastdom_1 = __importDefault(require("fastdom"));
const consts_1 = require("./consts");
const createCyclicTabbing = (config, getService) => {
    let enabledCyclicTabbingComponents = [];
    const window = globalThis.window;
    const environmentService = getService(definition_1.EnvironmentDefinition);
    const isSSR = environmentService.isSSR();
    const enableCyclicTabbing = (cyclicTabbingParentCompIds = []) => {
        if (isSSR) {
            return;
        }
        if (enabledCyclicTabbingComponents.length > 0) {
            restoreTabIndexes();
        }
        enabledCyclicTabbingComponents.push({
            cyclicTabbingParentCompIds,
        });
        preventElementsTabbing(cyclicTabbingParentCompIds);
    };
    const disableCyclicTabbing = (cyclicTabbingParentCompIds) => {
        if (isSSR) {
            return;
        }
        restoreTabIndexes();
        restorePreviousCyclicTabbing(cyclicTabbingParentCompIds);
    };
    // Inner functions
    const convertIdsToSelectors = (elementsIds) => {
        const elementsIdsArr = Array.isArray(elementsIds) ? elementsIds : [elementsIds];
        return elementsIdsArr.map(id => `#${id}`).join(',');
    };
    const preventElementTabbing = (focusableElement) => {
        const candidateTabIndex = focusableElement.getAttribute(consts_1.attributes.RESTORE_TAB_INDEX) || focusableElement.getAttribute('tabindex');
        fastdom_1.default.mutate(() => {
            focusableElement.setAttribute('tabindex', '-1');
            focusableElement.setAttribute(consts_1.attributes.RESTORE_TAB_INDEX, `${candidateTabIndex}`);
            if (config?.screenReaderFocus) {
                focusableElement.setAttribute(consts_1.attributes.ARIA_HIDDEN, 'true');
            }
        });
    };
    function preventElementsTabbing(cyclicTabbingParentCompIds) {
        function preventElementsTabbingInner() {
            const focusableElements = window.document.querySelectorAll(consts_1.tabbableSelectors.all);
            const excludedParentElements = cyclicTabbingParentCompIds
                ? Array.from(window.document.querySelectorAll(convertIdsToSelectors(cyclicTabbingParentCompIds)))
                : [];
            focusableElements.forEach(focusableElement => {
                if (!excludedParentElements.some(parent => parent.contains(focusableElement))) {
                    preventElementTabbing(focusableElement);
                }
            });
        }
        fastdom_1.default.measure(() => {
            preventElementsTabbingInner();
        });
    }
    const restoreTabIndexes = () => {
        fastdom_1.default.measure(() => {
            const focusableElements = window.document.querySelectorAll(`[${consts_1.attributes.RESTORE_TAB_INDEX}]`);
            focusableElements.forEach(focusableElement => {
                const restoredTabIndex = focusableElement.getAttribute(consts_1.attributes.RESTORE_TAB_INDEX);
                fastdom_1.default.mutate(() => {
                    if (restoredTabIndex === 'null') {
                        focusableElement.removeAttribute('tabindex');
                    }
                    else if (restoredTabIndex) {
                        focusableElement.setAttribute('tabindex', restoredTabIndex);
                    }
                    focusableElement.removeAttribute(consts_1.attributes.RESTORE_TAB_INDEX);
                    if (config?.screenReaderFocus) {
                        focusableElement.removeAttribute(consts_1.attributes.ARIA_HIDDEN);
                    }
                });
            });
        });
    };
    const restorePreviousCyclicTabbing = (cyclicTabbingParentCompIds) => {
        const parentSelectors = convertIdsToSelectors(cyclicTabbingParentCompIds);
        enabledCyclicTabbingComponents = enabledCyclicTabbingComponents.filter(component => convertIdsToSelectors(component.cyclicTabbingParentCompIds) !== parentSelectors);
        const lastModuleInFocus = enabledCyclicTabbingComponents.pop();
        if (lastModuleInFocus) {
            enableCyclicTabbing(lastModuleInFocus.cyclicTabbingParentCompIds);
        }
    };
    return {
        enableCyclicTabbing,
        disableCyclicTabbing,
    };
};
exports.createCyclicTabbing = createCyclicTabbing;
//# sourceMappingURL=cyclicTabbing.js.map